import { TellescopeModelFromName } from "@tellescope/tanstack-query";
import { Avatar, AvatarFallback, AvatarImage, Badge, ComboboxOptionRenderProps } from "@tellescope/ui";
import { formatInitials, formatName } from "@tellescope/utils";

export interface InboxZendeskRecipientItemProps extends ComboboxOptionRenderProps<string> {
  enduser?: TellescopeModelFromName<"endusers">;
  user?: TellescopeModelFromName<"users">;
  recipientType?: "enduser" | "agent";
}

export const InboxZendeskRecipientItem = ({ enduser, user, recipientType }: InboxZendeskRecipientItemProps) => {
  const entity = enduser ?? user;
  if (!entity) return null;

  const displayName = formatName(entity);
  const displayEmail = entity.email;

  return (
    <div className="flex gap-2 items-center justify-between w-full">
      <div className="flex gap-2 items-center min-w-0">
        <Avatar>
          <AvatarImage src={entity.avatar} />
          <AvatarFallback useStaticBackground={true} id={entity.id}>
            {formatInitials(entity)}
          </AvatarFallback>
        </Avatar>
        <div className="flex flex-col min-w-0">
          <p className="font-semibold truncate">{displayName}</p>
          {displayEmail && <p className="text-sm text-muted-foreground truncate">{displayEmail}</p>}
        </div>
      </div>
      {recipientType && (
        <Badge variant="outline" className="text-xs flex-shrink-0">
          {recipientType === "agent" ? "Agent" : "Enduser"}
        </Badge>
      )}
    </div>
  );
};
